import React from "react"
import "./cursorTrail.css"

const pixelCount = 48

const CursorTrail = () => {
  const pixelRefs = React.useRef([])

  React.useEffect(() => {
    const desktopPointer = window.matchMedia(
      "(hover: hover) and (pointer: fine) and (min-width: 768px) and (prefers-reduced-motion: no-preference)"
    )
    let isListening = false
    let pixelIndex = 0
    let lastPoint = { x: -100, y: -100 }

    const releasePixel = (x, y, index) => {
      const pixel = pixelRefs.current[pixelIndex]
      pixelIndex = (pixelIndex + 1) % pixelCount
      if (!pixel) return

      const angle = (Math.PI * 2 * index) / 5 + (Math.random() - 0.5) * 0.7
      const distance = 18 + Math.random() * 46
      const size = 2 + Math.round(Math.random() * 3)
      const originOffset = Math.random() * 9

      pixel.style.setProperty(
        "--pixel-x",
        `${x + Math.cos(angle) * originOffset}px`
      )
      pixel.style.setProperty(
        "--pixel-y",
        `${y + Math.sin(angle) * originOffset}px`
      )
      pixel.style.setProperty("--pixel-dx", `${Math.cos(angle) * distance}px`)
      pixel.style.setProperty("--pixel-dy", `${Math.sin(angle) * distance}px`)
      pixel.style.setProperty("--pixel-size", `${size}px`)
      pixel.classList.remove("cursor-trail__pixel--active")
      void pixel.offsetWidth
      pixel.classList.add("cursor-trail__pixel--active")
    }

    const moveTrail = event => {
      if (event.pointerType && event.pointerType !== "mouse") return

      const distance = Math.hypot(
        event.clientX - lastPoint.x,
        event.clientY - lastPoint.y
      )
      if (distance < 10) return

      lastPoint = { x: event.clientX, y: event.clientY }
      for (let index = 0; index < 5; index += 1) {
        releasePixel(event.clientX, event.clientY, index)
      }
    }

    const enable = () => {
      if (isListening || !desktopPointer.matches) return

      isListening = true
      window.addEventListener("pointermove", moveTrail, { passive: true })
    }

    const disable = () => {
      if (!isListening) return

      isListening = false
      window.removeEventListener("pointermove", moveTrail)
    }

    const handleMediaChange = () => {
      if (desktopPointer.matches) enable()
      else disable()
    }

    handleMediaChange()
    desktopPointer.addEventListener("change", handleMediaChange)

    return () => {
      disable()
      desktopPointer.removeEventListener("change", handleMediaChange)
    }
  }, [])

  return (
    <div className="cursor-trail" aria-hidden="true">
      {Array.from({ length: pixelCount }, (_, index) => (
        <span
          className="cursor-trail__pixel"
          key={index}
          ref={node => (pixelRefs.current[index] = node)}
        />
      ))}
    </div>
  )
}

export default CursorTrail
